export default function (instance) {
  return {
    add_country(payload) {
      return instance.post("administrator/add_country", {
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    update_country(payload) {
      return instance.post("administrator/update_country", {
        id: payload.id,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    delete_country(payload) {
      return instance.post("administrator/delete_country", {
        id: payload.id,
      });
    },
    add_oblast(payload) {
      return instance.post("administrator/add_oblast", {
        id_country: payload.id_country,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    update_oblast(payload) {
      return instance.post("administrator/update_oblast", {
        id: payload.id,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    delete_oblast(payload) {
      return instance.post("administrator/delete_oblast", {
        id: payload.id,
      });
    },
    add_rayon(payload) {
      return instance.post("administrator/add_rayon", {
        id_oblast: payload.id_oblast,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    update_rayon(payload) {
      return instance.post("administrator/update_rayon", {
        id: payload.id,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    delete_rayon(payload) {
      return instance.post("administrator/delete_rayon", {
        id: payload.id,
      });
    },
    add_mektep(payload) {
      return instance.post("administrator/add_mektep", {
        id_oblast: payload.id_oblast,
        id_rayon: payload.id_rayon,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    update_mektep(payload) {
      return instance.post("administrator/update_mektep", {
        id: payload.id,
        name_kg: payload.name_kg,
        name_ru: payload.name_ru,
        name_en: payload.name_en,
        id_integration: payload.id_integration,
      });
    },
    delete_mektep(payload) {
      return instance.post("administrator/delete_mektep", {
        id: payload.id,
      });
    },
  };
}
